/**
 * HOR Shop by Room — client-side image randomizer
 * ---------------------------------------------------------------
 * On each page load, replaces the static photo on every tile inside
 * the "Shop by room" section (sections/hor-categories.liquid) with a
 * random product image pulled live from that tile's linked collection.
 *
 * No Liquid / schema changes required — the collection handle is read
 * straight from each tile's existing href (e.g. /collections/dining).
 *
 * Include on the page with:
 *   <script src="{{ 'hor-shop-by-room-randomizer.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '.hor-cats';
  var TILE_SELECTOR = '.hor-cat-tile';
  var IMG_SELECTOR = '.hor-cat-photo img';

  // Per-pageview cache so we only fetch each collection once even if
  // init() runs again (e.g. after an InstantClick navigation).
  var cache = {};

  function getCollectionHandle(href) {
    if (!href) return null;
    var match = href.match(/\/collections\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function pickRandom(list) {
    return list[Math.floor(Math.random() * list.length)];
  }

  function extractImageUrls(products) {
    var urls = [];
    (products || []).forEach(function (product) {
      var src =
        (product.images && product.images[0] && product.images[0].src) ||
        (product.image && product.image.src);
      if (src) urls.push(src);
    });
    return urls;
  }

  function swapImage(tile, url) {
    var img = tile.querySelector(IMG_SELECTOR);
    if (!img || !url) return;
    // Preload off-DOM first so we never flash a broken/blank image.
    var preloader = new Image();
    preloader.onload = function () {
      img.src = url;
    };
    preloader.src = url;
  }

  function randomizeTile(tile) {
    var handle = getCollectionHandle(tile.getAttribute('href'));
    if (!handle) return;

    if (cache[handle]) {
      if (cache[handle].length) swapImage(tile, pickRandom(cache[handle]));
      return;
    }

    fetch('/collections/' + handle + '/products.json?limit=100')
      .then(function (res) {
        return res.ok ? res.json() : Promise.reject(res.status);
      })
      .then(function (data) {
        var urls = extractImageUrls(data.products);
        cache[handle] = urls;
        if (urls.length) swapImage(tile, pickRandom(urls));
      })
      .catch(function () {
        // Network/API hiccup: leave the merchant's static photo in place.
        cache[handle] = cache[handle] || [];
      });
  }

  function init() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;
    var tiles = root.querySelectorAll(TILE_SELECTOR);
    for (var i = 0; i < tiles.length; i++) {
      randomizeTile(tiles[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // This theme navigates via InstantClick (see layout/theme.liquid), which
  // swaps page content without a full reload. Re-run after each swap so the
  // tiles still re-randomize on "every page load" from the shopper's POV.
  if (window.InstantClick && typeof window.InstantClick.on === 'function') {
    window.InstantClick.on('change', init);
  }
})();
